export class SettingsController {
    constructor($scope, $state, $timeout, JFrogEventBus, XRayUIState, XRayUIStorage,$rootScope) {

        this.$scope = $scope;
        this.$rootScope=$rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.jfrogEventBus = JFrogEventBus;

        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.settingsMenuLocation = XRayUIState.getState('settingsMenuLocation');

        this.tabs = [{name: 'instances'},{name: 'database_sync'}, {name: 'users'}, {name: 'mail'}, {name: 'webhooks'}, {name: 'integrations'}, {name: 'proxy'}, {name: 'set_license'}, {name: 'general'}];


        if (this.$state.current.url == '/admin') {
            this.$state.go('home');
        }

        this.tabsDict = {
            instances: 'Artifactory',
            database_sync: 'Database Sync',
            users: 'Users',
            mail: 'Mail',
            webhooks: 'Webhooks',
            integrations: 'Integrations',
            proxy: 'Proxy',
            set_license: 'Register License',
            general: 'General Settings',
            system_logs: 'System Logs',
            permissions: 'Permissions',
            authentication: 'Authentication',
            repos: 'Artifactory',
            builds: 'Artifactory',
            failure_messages: 'System Messages',
            retry_messages: 'System Messages',
            system_monitoring: 'System Monitoring',
            ha: 'High Availability',
            support_page: 'Support Zone',
            httpconfig: 'HTTP Settings',
            system_licenses: 'Manage Licenses'
        };

        this.$timeout(()=> {
            this.syncTabsWithState();
        });

        /* $scope.$watch('Settings.$state.current', (newVal, oldVal) => {
             if (newVal.name.split('.')[1]) {
                 this.$state.params.tab = newVal.name.split('.')[1].toLowerCase();
             }
         })*/

    }

    syncTabsWithState() {
        let currentState = this.$state.current.name;
        let stateParts = currentState.split('.');
        if (stateParts[1]) {
            this.$state.params.tab = stateParts[1].toLowerCase();
            this.jfrogEventBus.dispatch(this.EVENTS.TABS_URL_CHANGED, this.$state.params);
        }
    }

    onTabChange() {
        this.$timeout(()=>{

            let currentTab = this.$state.params.tab;
            if (currentTab) {
                console.log('changed tab');//this.$state.go('settings.'+currentTab);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/settings.controller.js